<section class="flex-container">
  <div class="flex-row flex-justify-center">
    <div class="flex-col-4 flex-col-sm-12">
      <h2>{{ productTitle | translate: { kidsName: currentAccountDetail.owner_name } }}</h2>
      <p>{{ 'adjust_screen.p1' | translate }}</p>
      <p>{{ 'adjust_screen.p2' | translate }}</p>
      <div class="what-you-can" [class.hide-personalisation]="isEve2">
        <h4>{{ 'adjust_screen.h4_1' | translate }}</h4>
        <ul>
          @if (!isEve2) {
            <li>{{ 'adjust_screen.li1_1' | translate }}</li>
            <li>{{ 'adjust_screen.li1_2' | translate }}</li>
          }
          <li>{{ 'adjust_screen.li1_3' | translate }}</li>
        </ul>
        <img src="/assets/images/adjust-flower.png" />
      </div>
      <div class="what-we-do">
        <h4>{{ 'adjust_screen.h4_2' | translate }}</h4>
        <p [innerHtml]="'adjust_screen.li2_1' | translate"></p>
        <p [innerHtml]="'adjust_screen.li2_2' | translate"></p>
        <p [innerHtml]="'adjust_screen.li2_3' | translate"></p>
        <p [innerHtml]="'adjust_screen.li2_4' | translate"></p>
      </div>
      <p [innerHtml]="'adjust_screen.p3' | translate"></p>
      <div class="doc-notification warning">
        <span class="icon-i-warning"></span>
        <p [innerHtml]="'adjust_screen.p4' | translate"></p>
      </div>
      <button (click)="back()" class="ui-button full-width">{{ 'adjust_screen.cta_no' | translate }}</button>
      <button (click)="changeStrategy()" class="ui-button secondary full-width" [disabled]="editDisabled">
        {{ 'adjust_screen.cta_yes' | translate }}
      </button>
    </div>
  </div>
</section>
